import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { HeaderData } from 'modules/finance/components/FinancialWorkspace/types/table'

import { ComparisonHeader } from './ComparisonHeader'
import { RegularHeader } from './RegularHeader'

interface Props {
  title: string
  isGrouped: boolean
  totalCount: number
  headers: string[] | HeaderData[]
}

export const Header = (props: Props) => {
  const { hasComparisonDate } = useFinancialWorkspace()

  return hasComparisonDate ? <ComparisonHeader {...props} /> : <RegularHeader {...props} />
}
